import BaseModule from '@core/modules/base-module/base-module';
import NewsCard from '@core/components/cards/news-card/news-card';
//
const newsList = new BaseModule();
newsList.name = "news-list";
newsList.init((that)=>{
  const card=new NewsCard(that.elements);
  card.init();
});
